import React from "react";
import { Box, Grid, Typography, Paper, Divider, Container } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import Logo from '../../assets/images/MC3.png';
import { Link } from "react-router-dom";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: "#fffff",
                py: 4,
                px: 2,
                // mt: 4,
                borderTop: "1px solid #e0e0e0",
            }}
        >
            <Container>
                <Grid container spacing={4}>
                    {/* Left Section */}
                    <Grid item xs={12} md={4}>
                        <Box display="flex" flexDirection="column" alignItems="flex-start">
                            <Box
                                component="img"
                                src={Logo}
                                alt="MC3 Smart Tach"
                                sx={{ height: "80px", width: "auto", display: "inline-block" }}
                            />
                            <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                                We are committed to providing the best services to our customers. Our solutions are designed to help you achieve your goals efficiently and effectively.
                            </Typography>

                        </Box>
                    </Grid>

                    {/* Middle Section */}
                    <Grid item xs={12} md={4}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Typography variant="h6" fontWeight="bold">
                                    Quick Links
                                </Typography>
                                {["Home", "About Us", "Our Services", "Careers"].map((link, index) => (
                                    <Typography key={index} variant="body2" sx={{ mt: 1 }}>
                                        <Link
                                            to={`/${link.toLowerCase().replace(/\s+/g, "-")}`} // Convert link text to URL path
                                            style={{ textDecoration: "none", color: "inherit" }}
                                        >
                                            {link}
                                        </Link>
                                    </Typography>
                                ))}
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="h6" fontWeight="bold">
                                    Community
                                </Typography>
                                {["Support", "Contact Us"].map((link, index) => (
                                    <Typography key={index} variant="body2" sx={{ mt: 1 }}>
                                        <Link
                                            to={`/${link.toLowerCase().replace(/\s+/g, "-")}`}
                                            style={{ textDecoration: "none", color: "inherit" }}
                                        >
                                            {link}
                                        </Link>
                                    </Typography>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* Right Section */}
                    {/* Right Section */}
                    <Grid item xs={12} md={4}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                backgroundColor: "#f0f8ff",
                                borderRadius: 2,
                            }}
                        >
                            <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
                                Contact Us
                            </Typography>
                            <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
                                <EmailIcon sx={{ color: "#00bfff", mr: 1 }} />
                                <Typography variant="body2">
                                    <a
                                        href=" "
                                        style={{ textDecoration: "none", color: "inherit" }}
                                    >
                                        contact@mc3smarttech.com
                                    </a>
                                </Typography>
                            </Box>
                            <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
                                <PhoneIcon sx={{ color: "#00bfff", mr: 1 }} />
                                <Typography variant="body2">+1 518 394 4014</Typography>
                            </Box>
                            <Box display="flex" alignItems="flex-start">
                                <LocationOnIcon sx={{ color: "#00bfff", mr: 1 }} />
                                <Typography
                                    variant="body2"
                                    sx={{ color: "textSecondary", mt: 1, lineHeight: "1.5" }}
                                >
                                    New Forest Enterprise Centre, <br />
                                    Unit 36b, Chapel Lane, <br />
                                    Totton, Southampton, SO40 9LA
                                </Typography>
                            </Box>
                        </Paper>
                    </Grid>

                </Grid>

                {/* Footer Bottom */}
                <Divider sx={{ my: 3 }} />
                <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
                    <Typography variant="body2" color="textSecondary">
                        © Copyright 2025. All Rights Reserved By{" "}
                        <Typography
                            component="span"
                            sx={{ color: "#00bfff", fontWeight: "bold" }}
                        >
                            MC3 SMARTECH
                        </Typography>
                    </Typography>
                    <Box display="flex" gap={2}>
                        {["Privacy Policy", "Terms of Service"].map((item, index) => (
                            <Typography key={index} variant="body2">
                                <Link
                                    to={`/${item.toLowerCase().replace(/\s+/g, "-")}`}
                                    style={{ textDecoration: "none", color: "inherit" }}
                                >
                                    {item}
                                </Link>
                            </Typography>
                        ))}
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
